import { motion } from 'motion/react';
import styled, { css } from 'styled-components';
import themeColors from 'styles/config/colors';
import sizes from 'styles/config/sizes';
import themeSpacing from 'styles/config/spacing';
import rem from 'styles/functions/rem';

import Clickable from 'components/atoms/Clickable';
import { LegacyTag as TagAtom } from 'components/atoms/LegacyTag';
import { Body, BodyStrong } from 'components/atoms/LegacyText';

const noOverflowMixin = css`
  overflow: hidden;
  max-width: ${sizes.maxNavTextWidth}px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ActiveNavText = styled(BodyStrong)`
  ${noOverflowMixin}
  color: ${themeColors.textPrimaryInverse};
`;

export const NavText = styled(Body)`
  ${noOverflowMixin}
`;

export const NavClickable = styled(Clickable)`
  display: flex;
  flex: 1;
  align-items: center;

  margin-right: -${themeSpacing.xs1};
  margin-left: -${themeSpacing.xs1};
  padding: ${themeSpacing.xs1};

  border-radius: ${rem(4)};

  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${themeColors.backgroundInverseHover};
  }
`;

export const NavSectionItemContainer = styled(motion.li)`
  position: relative;

  display: flex;
  justify-content: space-between;

  padding-top: ${themeSpacing.xs2};

  list-style: none;

  & .mainNavContent {
    svg {
      flex-shrink: 0;
      margin-right: ${themeSpacing.sm1};
    }
  }
`;

export const Tag = styled(TagAtom)`
  margin-left: auto;
  background-color: ${themeColors.backgroundAccentInverse};
  border: none;

  & p {
    color: ${themeColors.textPrimaryInverse};
  }
`;
